import { ProductDetailsMainContent } from "../product-content/ProductDetailsMainContent";
// import './AppBody.css'

export default function ProductDetailsBody ({reloadHeader}) {
  return (
      <div className="view-qualities folded router-view-container">
        <ProductDetailsMainContent reloadHeader={reloadHeader}/>
    </div>
  )
}